import WasmController from "react-lib/frameworks/WasmController";

// Type
import {
  State as MeFormState,
  Event as MeFormEvent,
  Data as MeFormData
} from "./MeFormType";
import {
  State as MeCastState,
  Event as MeCastEvent,
  Data as MeCastData
} from "./MeCastType";

// Sequence
import * as MeFormI from "./sequence/MeForm";
import * as MeCastI from "./sequence/MeCast";

export type State = {
  MeCastDefaultTabIndex: number;
} 
  & MeFormState
  & MeCastState;

export const StateInitial: State = {
  MeCastDefaultTabIndex: 0,
  ...MeFormI.StateInitial,
  ...MeCastI.StateInitial,
};

export type Event = 
  | { message: "RunSequence"; params: any }
  | { message: "GetMasterData"; params: {} }
  | MeFormEvent
  | MeCastEvent;

export type Props = {};

export type Data = {}
  & MeFormData
  & MeCastData;

export const DataInitial = {};

export type Handler = (
  controller: WasmController<State, Event, Data, Props>,
  params?: any
) => any;